

/* Swiper */

import Swiper from "swiper";
// import Swiper, { Navigation, Pagination, Scrollbar } from "swiper";
import "swiper/css";



import massimo from "./js/massimo";
massimo();

import navbar from "./js/navbar";
navbar();

import footer from "./js/footer";
footer();

import sidebar from "./js/sidebar";
sidebar();

import search from "./js/search";
search();

import scrollTop from "./js/scrollTop";
scrollTop();

import heroSplit from "./js/blocks/hero-split";
heroSplit();

import reveal from "./js/reveal";
reveal();

import previewDestinazioni from "./js/blocks/preview-destinazioni";
previewDestinazioni();

import caroselloTipologie from "./js/blocks/carosello-tipologie";
caroselloTipologie();
import caroselloManuale from "./js/blocks/carosello-manuale";
caroselloManuale();

import accordion from "./js/blocks/accordion";
accordion();

import archivioCasehistory from "./js/blocks/archivio-casehistory";
archivioCasehistory();

import zoomScroll from "./js/blocks/zoom-scroll";
zoomScroll();

import contactModal from "./js/blocks/contact-modal";
contactModal();
